import React from 'react'
import PropTypes from 'prop-types'
import { GreetingTitle } from 'LiveBoard/components/shared/GreetingCard'
import { PersonalDetails } from 'LiveBoard/components/shared/SellerCard/PersonalDetails'
import { LogosArea } from 'LiveBoard/components/shared/LogosArea'
import { Banner } from 'LiveBoard/components/shared/Banner'
import { TAB_INDEXES } from 'shared/helpers/AccessibilityHelper'

import './style.css.scss'

class GreetingCard extends React.Component  {
  constructor(props) {
    super(props)
    this.state = { animate: false }
  }

  componentDidMount() {
    this.component.addEventListener("touchstart", this.handleClose)
  }

  componentWillUnmount() {
    const { onClose } = this.props
    onClose && onClose()
  }

  handleClose = () => {
    this.setState({ animate: true })
    setTimeout(() => this.props.onClose(), 2000)
  }

  render() {
    const {
      config, onClose, banner, logo, lead, seller,
      themeColorHex, textColor
    } = this.props

    return config.show && (
      <div
        className={`greeting-card-container ${this.state.animate ? 'animate' : ''}`}
        onClick={this.handleClose}
        ref={ref => this.component = ref}
        tabIndex={TAB_INDEXES.GreetingCard}>
        { banner.show &&
          <Banner
            config={banner}
            themeColorHex={themeColorHex}
            showContent={false}
            textColor={textColor}
            isMobile={true}
          /> }
        <LogosArea config={{logo}}/>
        <div className='greeting-card-content' style={{color: textColor}}>
          {config.show_title && <GreetingTitle lead={lead} config={config} />}
          <p>{config.text}</p>
          <PersonalDetails
            textColor={textColor}
            seller={seller} />
        </div>
      </div>
    )
  }
}

GreetingCard.propTypes = {
  lead: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  banner: PropTypes.object.isRequired,
  logo: PropTypes.object.isRequired,
  seller: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  textColor: PropTypes.string.isRequired
}

export default GreetingCard
